import { buildAgentStatus, type ONLINE_STATUS } from 'gcs-common/helper/userStatusHelper';
import { useUpdateCurrentUserMutation } from './current-user-api';

export function useUpdateAgentStatus() {
  const updateCurrentUserMutation = useUpdateCurrentUserMutation();

  async function updateAgentStatus({ statusType }: { statusType: ONLINE_STATUS }) {
    const status = buildAgentStatus({ statusType });
    await updateCurrentUserMutation.mutateAsync({
      body: { status },
    });
  }

  return { updateAgentStatus, isPending: updateCurrentUserMutation.isPending };
}
